import styled from 'styled-components'
import * as React from 'react'
import {LeftRowFlexContainer, RowFlexContainer} from '../FlexComponents'
import HintButton from '../../components/shared/pageBaseComponents/HintButton'
import {TableCellProps} from '@mui/material/TableCell';
import {ChipProps} from '@mui/material/Chip';
import {Box, Chip, Table, TableBody, TableCell, TableHead, TableProps, TableSortLabel,} from '@mui/material';
import withStyles from '@mui/styles/withStyles';

export const StyledTableCaption = styled.caption`
  text-align: left !important;
  background-color: gainsboro !important;
  padding: .5rem 0 .5rem .75rem !important;
  font-size: 1.2rem !important;
  caption-side: top !important;
`
export const TableRowName: React.FC<TableCellProps &
    { required?: boolean, optional?: boolean, rowSpan?: number, hint?: string }> = props => {
    return (<MinTableCell rowSpan={props.rowSpan}>
        <NoWrapRowFlexContainer>
            {
                props.hint ?
                    <LeftRowFlexContainer>
                        <Box pr={'10px'}>{props.children}</Box>
                        <HintButton message={props.hint}/>
                    </LeftRowFlexContainer> : props.children
            }
            {
                props.required &&
                (<Box ml={'20px'}><RequiredChip label={'必須'}/></Box>)
            }
            {
                props.optional &&
                (<Box ml={'20px'}><OptionalChip label={'任意'}/></Box>)
            }
        </NoWrapRowFlexContainer>
    </MinTableCell>)
}

export const NoWrapTableSortLabel = styled(TableSortLabel)`
  white-space: nowrap;
`
export const NoWrappedTableCell = styled(TableCell)`
  white-space: nowrap;
`

export const RequiredChip = (props: ChipProps) => (
    <Chip
        style={{color: `#F50057`, width: `44px`, borderColor: `#F50057`}}
        color={'secondary'}
        size={'small'}
        variant={'outlined'}
        {...props}
    />
)

export const OptionalChip = (props: ChipProps) => (
    <Chip
        style={{color: `rgba(112, 112, 112, 0.68)`}}
        size={'small'}
        variant={'outlined'}
        {...props}
    />
)

const NoWrapRowFlexContainer = styled(RowFlexContainer)`
  white-space: nowrap;
`

const MinTableCell = styled(TableCell)`
  width: 1px;
`


const InnerTable = styled(Table)`
  margin-left: 15px;
  width: auto!important;
`

export const TableFixed = styled(Table)`
   table-layout: fixed;
`;

export const InnerMiniTable = (props: TableProps) => <InnerTable size={'small'}>{props.children}</InnerTable>

export const InnerMiniTableCell = styled(TableCell)`
  padding: 8px!important;
`

export const InnerMiniTableBody = styled(TableBody)``

export const WrapTableRowName: React.FC<TableCellProps & { required?: boolean, rowSpan?: number }> = props => {
    return (<MinTableCell rowSpan={props.rowSpan}>
        <WrapRowFlexContainer>
            {props.children}
            {
                props.required &&
                (<Box ml={'20px'}><RequiredChip label={'必須'}/></Box>)
            }
        </WrapRowFlexContainer>
    </MinTableCell>)
}

const WrapRowFlexContainer = styled(RowFlexContainer)`
  word-break: break-all;
`


export const TableRowNameTop: React.FC<TableCellProps & { required?: boolean, rowSpan?: number }> = props => {
    const {...rest} = props
    return (<VerticalAlignTableCell rowSpan={props.rowSpan} vertical={'top'} {...rest}>
        <NoWrapRowFlexContainer>
            {props.children}
            {
                props.required &&
                (<Box ml={'20px'}><RequiredChip label={'必須'}/></Box>)
            }
        </NoWrapRowFlexContainer>
    </VerticalAlignTableCell>)
}

const VerticalAlignTableCell = styled(MinTableCell)<{ vertical: string}>`
  &.MuiTableCell-root {
    vertical-align:  ${props => props.vertical};
  };
`

export const SecondaryTableRowName =
    styled(({end, ...props}) => (<TableCell {...props} />))<TableCellProps & { end?: boolean }>`
  &.MuiTableCell-root {
    ${props => (props.end)
        ? `padding: 14px 0 14px 24px;`
        : `padding: 14px 0 0 24px;
     border: 0;`
    };
    width: 0;
    white-space: nowrap;
    vertical-align: top;
  }
`

export const SecondaryTableCell = styled(SecondaryTableRowName)`
  &.MuiTableCell-root {
    padding-right: 12px;
    white-space: pre-wrap;
    overflow-wrap: anywhere;
  }
`

export const LightGrayTableHeadColor: string = '#FAFAFA'

export const LightGrayTableHead = withStyles({
    root: {
        backgroundColor: LightGrayTableHeadColor,
    },
})(TableHead)
